import { instanceAuth } from "api/apiConfig"

export const reportingCountryWiseAPI = async data => {
  try {
    const response = await instanceAuth.get("Finance/country-wise", {
      params: {
        ...data,
      },
    })
    return response
  } catch (error) {
    console.log("error fetching country-wise report...", error)
    throw error
  }
}
